var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInternational)?_c('GlobalHome'):_c('UnGlobalHome')
}
var staticRenderFns = []

export { render, staticRenderFns }